import { Entity, JoinColumn, ManyToOne } from 'typeorm';
import { booleanTransformer, GenPartial, momentTransformer } from 'typeormgen';
import ChangeLookPicture from '../change-look-pictures/change-look-picture.entity';
import { COLORS } from '../enums/enums';
import HaChange from '../ha-changes/ha-change.entity';
import Picture from '../pictures/picture.entity';

@Entity('ha_look_pictures')
export default class HaLookPicture extends ChangeLookPicture {
	static tableName = 'ha_look_pictures';

	@ManyToOne((type) => HaChange, (haChange) => haChange.haLookPictures)
	@JoinColumn({
		name: 'change_id',
	})
	haChange: HaChange;

	@ManyToOne((type) => Picture, (picture) => picture.haLookPictures)
	@JoinColumn({ name: 'picture_id' })
	picture: Picture;

	static rules() {
		return {
			...super.rules(),
		};
	}

	toJSON() {
		return {
			...super.toJSON(),
		};
	}

	assign(props?: GenPartial<HaLookPicture>) {
		super.assign(props);

		if (props) {
			if (typeof props.main_photo !== 'undefined') {
				this.main_photo = booleanTransformer.from(props.main_photo);
			}
			if (typeof props.last_updated_time !== 'undefined') {
				this.last_updated_time = momentTransformer.from(
					props.last_updated_time
				);
			}
			if (typeof props.date_created !== 'undefined') {
				this.date_created = momentTransformer.from(props.date_created);
			}
		}
	}

	constructor(props?: GenPartial<HaLookPicture>) {
		super(props);
	}

	getTagColor() {
		return COLORS.HAIR_LIGHT;
	}

	getTagRemoveColor() {
		return COLORS.HAIR;
	}
}
